import React, { useEffect, useState } from 'react';
import numeral from 'numeral';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component-with-filter';


import ToggleSwitch from 'SharedComponents/toggle-switch';
import PopoverHover from 'SharedComponents/popover-hover';
//import ActionButton from 'SharedComponents/action-button';
import ModalDialogV3 from 'SharedComponents/modal-dialog-v3';
import DirectDebitRequestContent from 'SharedComponents/direct-debit-request-content';

import * as RoundUpsActions from 'Flux/round-ups/actions';

import log from 'Utils/logger';

import styles from './index.css';

numeral.defaultFormat('00.00');

const RoundUpsAcctsTableWrapper = styled.div`${styles}`;

const RoundUpsAcctsTable = ({ onError,}) => {
  
  const dispatch = useDispatch();
  const roundUpsLinkedAccounts = useSelector((state) => state.roundups.linkedAccounts || []);
  const acceptedRoundupsTerms = useSelector((state) => state.roundups.acceptedRoundupsTerms);
  const authentication = useSelector((state) => state.authentication);
  console.log('RoundUpsAcctsTable triggered with roundUpsLinkedAccounts', roundUpsLinkedAccounts);


  const [linkedAccounts, setLinkedAccounts] = useState(roundUpsLinkedAccounts);
  const [updatingRoundUpsEnabledStates, setUpdatingRoundUpsEnabledStates] = useState(new Array(linkedAccounts.length).fill(false));
  const [updatingActiveDebitEnabledStates, setUpdatingActiveDebitEnabledStates] = useState(new Array(linkedAccounts.length).fill(false));

  const [updatingAccountRoundupStatus, setUpdatingAccountRoundupStatus] = useState(false);
  const [updatingAccountDebitStatus, setUpdatingAccountDebitStatus] = useState(false);

  const [showRoundUpTermsModal, setShowRoundUpTermsModal] = useState(false);
  const [updatingAcceptedRoundUpTerms, setUpdatingAcceptedRoundUpTerms] = useState(false);
  const [pendingDebitChange, setPendingDebitChange] = useState(null);
  //const [activeRoundUpTermsTab, setActiveRoundUpTermsTab] = useState('dd-request');

  //delete after testing
  const TEST_ROUND_UP_TERMS_MODAL = false;

  const generateFalseArray = (length) => new Array(length).fill(false);

  const resetUpdatingActiveDebitEnabledStates = () => {
    const newUpdatingStates = generateFalseArray(linkedAccounts.length);
    console.log('* resetUpdatingActiveDebitEnabledStates triggered with newUpdatingStates: ', newUpdatingStates);
    setUpdatingActiveDebitEnabledStates(newUpdatingStates);
  };

  const setDebitAccountUpdating = (index) => {
    const newUpdatingStates = generateFalseArray(linkedAccounts.length);
    newUpdatingStates[index] = true;
    setUpdatingActiveDebitEnabledStates(newUpdatingStates);
  };

  const resetUpdatingRoundUpsEnabledStates = () => {
    const newUpdatingStates = generateFalseArray(linkedAccounts.length);
    console.log('* resetUpdatingRoundUpsEnabledStates triggered with newUpdatingStates: ', newUpdatingStates);
    setUpdatingRoundUpsEnabledStates(newUpdatingStates);
  };
  // const [updatingStates, setUpdatingStates] = useState(roundUpsLinkedAccounts.map(() => false));

  useEffect(() => {
    console.log('*useEffect roundUpsLinkedAccounts triggered with roundUpsLinkedAccounts: ', roundUpsLinkedAccounts);
    console.log('*useEffect roundUpsLinkedAccounts triggered with linkedAccounts: ', linkedAccounts);
    setLinkedAccounts(roundUpsLinkedAccounts);
    
    setUpdatingRoundUpsEnabledStates(
      generateFalseArray(roundUpsLinkedAccounts.length)
    );

    setUpdatingActiveDebitEnabledStates(
      generateFalseArray(roundUpsLinkedAccounts.length)
    );
  }, [roundUpsLinkedAccounts]);

  useEffect(() => {
    const hasDebitEnabledAccount = linkedAccounts.some((account) => account.debit_enabled);
    const hasRoundupEnabledAccount = linkedAccounts.some((account) => account.roundup_enabled);
    if (!hasDebitEnabledAccount) {
      const errorMessage1 = 'You will need to set an account to Debit Enabled so we can transfer funds to your super.';
      onError(errorMessage1);
    } else if (!hasRoundupEnabledAccount) {
      const errorMessage2 = 'You will need to enable Round Ups on at least one account so we can calculate Round Ups amounts';
      onError(errorMessage2);
    } else {
      onError('');
    }
  }, [linkedAccounts, onError]);

  async function enableAccountRoundups(account_id, newRoundUpEnabledStatus) {
    console.log('*enableAccountRoundups triggered with account_id: ', account_id);
    console.log('*enableAccountRoundups triggered with newRoundUpEnabledStatus: ', newRoundUpEnabledStatus);
    setUpdatingAccountRoundupStatus(true);

    try {
      // const updatedAccounts = [...linkedAccounts];
      const result = await dispatch(RoundUpsActions.enableAccountRoundUps(account_id, newRoundUpEnabledStatus));
      console.log('*enableAccountRoundups using result: ', result);
      console.log('*enableAccountRoundups.data.data result: ', result.data.data);
      if (result.data) {
        dispatch(RoundUpsActions.setRoundUpsShopperData(result.data.data));
      } else {
        console.log('enableAccountRoundups result.data.data is null'); // get rid of else after testing
      }

      // RoundUpsActions.setRoundUpsLinkedAccounts(updatedAccounts);
    } catch (exception) {
      console.log('enableAccountRoundups exception: ', exception);
      log({
        event: 'System-Error',
        source: 'RoundUps Table - enableAccountRoundups',
        info: exception,
        shopper_id: authentication?.user ? authentication.user.shopper_id : 'Not Signed In',
        ...exception,
      });
      onError(exception);
    } finally {
      console.log('* time to reset updating RoundUPs Enabled states');
      resetUpdatingRoundUpsEnabledStates();
      setUpdatingAccountRoundupStatus(false);
      console.log('finally in setUpdatingAccountRoundupStatus has inkedAccounts: ', linkedAccounts);
    }
  }

  async function enableAccountDebit(account_id, newRoundUpEnabledStatus) {
    console.log('*enableAccountDebit triggered with account_id: ', account_id);
    console.log('*enableAccountDebit triggered with newRoundUpEnabledStatus: ', newRoundUpEnabledStatus);
    setUpdatingAccountDebitStatus(true);

    try {
      // const updatedAccounts = [...linkedAccounts];
      const result = await dispatch(RoundUpsActions.enableAccountDebit(account_id, newRoundUpEnabledStatus));
      console.log('*enableAccountDebit using result: ', result);
      console.log('*enableAccountDebit.data.data result: ', result.data.data);
      if (result.data) {
        dispatch(RoundUpsActions.setRoundUpsShopperData(result.data.data));
      } else {
        console.log('setRoundUpsShopperData result.data.data is null'); // get rid of else after testing
      }
    } catch (exception) {
      console.log('enableAccountDebit exception: ', exception);
      log({
        event: 'System-Error',
        source: 'RoundUps Table - enableAccountDebit',
        info: exception,
        shopper_id: authentication?.user ? authentication.user.shopper_id : 'Not Signed In',
        ...exception,
      });
      // onError(exception);
    } finally {
      console.log('* time to reset updating RoundUPs Enabled states');
      resetUpdatingActiveDebitEnabledStates();
      setUpdatingAccountDebitStatus(false);
      console.log('finally in setUpdatingAccountRoundupStatus has inkedAccounts: ', linkedAccounts);
    }
  }

  async function updateAcceptedRoundUpTerms() {
    console.log(
      'RoundUpsAcctsTable - updateAcceptedRoundUpTerms triggered with !acceptedRoundupsTerms: ',
      !acceptedRoundupsTerms
    );

    setUpdatingAcceptedRoundUpTerms(true);

    try {
      const result = await dispatch(
        RoundUpsActions.updateAcceptedRoundUpsTerms(
          !acceptedRoundupsTerms
        )
      );

      console.log(
        'RoundUpsAcctsTable - updateAcceptedRoundUpsTerms using result: ',
        result
      );

      dispatch(
        RoundUpsActions.setAcceptedRoundUpsTerms(
          result.data.data.acceptedRoundupsTerms
        )
      );

      return result.data.data.acceptedRoundupsTerms;
    } catch (exception) {
      console.log(
        'RoundUpsAcctsTable - updateAcceptedRoundUpTerms exception: ',
        exception
      );

      log({
        event: 'System-Error',
        shopper_id: authentication?.user
          ? authentication.user.shopper_id
          : 'Not Signed In',
        source:
          'RoundUpsAcctsTable- UpdateAcceptedRoundUpTerms',
        info: exception,
        ...exception,
      });

      onError('Error - please try again');

      return false;
    } finally {
      setUpdatingAcceptedRoundUpTerms(false);
    }
  }

  const toggleAcceptedRoundUpTerms = async () => {
    console.log(
      'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms triggered'
    );

     //delete this after testing
    if (TEST_ROUND_UP_TERMS_MODAL) {
      console.log(
        'RoundUpsAcctsTable - TEST MODE - skipping terms update and enableAccountDebit'
      );
      return;
    }
    console.log(
      'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms acceptedRoundupsTerms: ',
      acceptedRoundupsTerms
    );
    console.log(
      'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms !acceptedRoundupsTerms: ',
      !acceptedRoundupsTerms
    );

    if (
      updatingAcceptedRoundUpTerms ||
      updatingAccountDebitStatus
    ) {
      console.log(
        'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms update already in progress'
      );
      return;
    }

    if (!pendingDebitChange) {
      console.log(
        'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms no pendingDebitChange'
      );
      return;
    }

    const accepted = await updateAcceptedRoundUpTerms();

    console.log(
      'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms accepted result: ',
      accepted
    );

    if (!accepted) {
      console.log(
        'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms terms were not accepted'
      );
      return;
    }

    const {
      accountId,
      index,
      newDebitEnabledStatus,
    } = pendingDebitChange;

    console.log(
      'RoundUpsAcctsTable - toggleAcceptedRoundUpTerms enabling pending debit account: ',
      pendingDebitChange
    );

    setShowRoundUpTermsModal(false);
    setPendingDebitChange(null);
    setDebitAccountUpdating(index);

    await enableAccountDebit(
      accountId,
      newDebitEnabledStatus
    );
  };

  const closeRoundUpTermsModal = () => {
    console.log(
      'RoundUpsAcctsTable - closeRoundUpTermsModal triggered'
    );

    if (updatingAcceptedRoundUpTerms) {
      console.log(
        'RoundUpsAcctsTable - closeRoundUpTermsModal acceptance update in progress'
      );
      return;
    }

    setShowRoundUpTermsModal(false);
    setPendingDebitChange(null);
    //setActiveRoundUpTermsTab('dd-request');
    resetUpdatingActiveDebitEnabledStates();
  };

  const roundupInfo = (
    <span className="pop-over-container">
      <PopoverHover
        content={(
          <div style={{
            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
          }}
          >
            If enabled then spending on this account will be Rounded Up and sourced from your Debit Enabled account to be paid to your super.
          </div>
            )}
        header={null}
        img={null}
        itemToPopover={
              (<i className="material-icons" style={{ margin: '0 5px 0 5px', verticalAlign: '-40%' }}>info</i>)
            }
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      />
    </span>
  );

  const debitInfo = (
    <span className="pop-over-container">
      <PopoverHover
        content={(
          <div style={{
            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
          }}
          >
            You must have one account Debit Enabled where you source funds for your super. This account cannot be a credit, loan or mortgage account
          </div>
            )}
        header={null}
        img={null}
        itemToPopover={
              (<i className="material-icons" style={{ margin: '0 5px 0 5px', verticalAlign: '-40%' }}>info</i>)
            }
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      />
    </span>
  );

  const unavailableMessage = (
    <span className="pop-over-container">
      <PopoverHover
        content={(
          <div style={{
            maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
          }}
          >
            This account is unavailable for Round-Ups. It may be closed or sharing of account transactions to Boost Your Super is not enabled. To make it available you can try CONNECT A BANK using the button below and sharing transactions with POKITPAL who are the Round-Ups service provider for Boost Your Super.
          </div>
        )}
        header={null}
        img={null}
        itemToPopover={
          (<i className="material-icons" style={{ margin: '0 5px 0 5px', verticalAlign: '-40%' }}>info</i>)
        }
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
      />
    </span>
  );

  const handleToggleEnableAccountRoundUps = (accountId, property, index) => {
    console.log('*handleToggle triggered with accountId: ', accountId);
    console.log('*handleToggle triggered with property: ', property);
    console.log('*handleToggle triggered with index: ', index);

    if (updatingAccountRoundupStatus) {
      return;
    }

    if (property === 'activeRoundUpsEnabled') {
      const newUpdatingStates = [...updatingRoundUpsEnabledStates];
      newUpdatingStates[index] = true;
      console.log('*handleToggle lets set updatingRoundUpsEnabledStates: ', newUpdatingStates);
      setUpdatingRoundUpsEnabledStates(newUpdatingStates);
    } else if (property === 'activeDebitEnabled') {
      const newUpdatingStates = [...updatingActiveDebitEnabledStates];
      newUpdatingStates[index] = true;
      console.log('*handleToggle lets set updatingActiveDebitEnabledStates: ', newUpdatingStates);
      setUpdatingActiveDebitEnabledStates(newUpdatingStates);
    }

    console.log('*handleToggle lets call enableAccountRoundups with !linkedAccounts[index].roundup_enabled: ', !linkedAccounts[index].roundup_enabled);
    enableAccountRoundups(accountId, !linkedAccounts[index].roundup_enabled);
  };

  const handleToggleEnableAccountDebit = (accountId, property, index) => {
    console.log(
      'RoundUpsAcctsTable - handleToggleEnableAccountDebit triggered with accountId: ',
      accountId
    );
    console.log(
      'RoundUpsAcctsTable - handleToggleEnableAccountDebit triggered with property: ',
      property
    );
    console.log(
      'RoundUpsAcctsTable - handleToggleEnableAccountDebit triggered with index: ',
      index
    );

    if (
      updatingAccountDebitStatus ||
      updatingAcceptedRoundUpTerms
    ) {
      console.log(
        'RoundUpsAcctsTable - handleToggleEnableAccountDebit update already in progress'
      );
      return;
    }

    const account = linkedAccounts[index];

    if (!account) {
      console.log(
        'RoundUpsAcctsTable - handleToggleEnableAccountDebit account not found'
      );
      onError('Unable to find the selected account.');
      return;
    }

    const newDebitEnabledStatus = !account.debit_enabled;

    console.log(
      'RoundUpsAcctsTable - handleToggleEnableAccountDebit newDebitEnabledStatus: ',
      newDebitEnabledStatus
    );

    const requiresTermsAcceptance = newDebitEnabledStatus && !acceptedRoundupsTerms;
    //const requiresTermsAcceptance = newDebitEnabledStatus;

    console.log(
      'RoundUpsAcctsTable - handleToggleEnableAccountDebit requiresTermsAcceptance: ',
      requiresTermsAcceptance
    );

    if (requiresTermsAcceptance) {
      console.log(
        'RoundUpsAcctsTable - handleToggleEnableAccountDebit opening Direct Debit Request modal'
      );

      setPendingDebitChange({
        accountId,
        index,
        newDebitEnabledStatus,
      });

      //setActiveRoundUpTermsTab('dd-request');

      setShowRoundUpTermsModal(true);
      return;
    }

    setDebitAccountUpdating(index);

    enableAccountDebit(
      accountId,
      newDebitEnabledStatus
    );
  };

  const ExpandedComponent = ({ data }) => {
    const rowNumber = linkedAccounts.findIndex((account) => account.id === data.id);

    return (
      <div className="expander-row-container">
        <div className="account-details">

          <div className="account-details-item">
            <span style={{ fontWeight: 'bold', fontSize: 'larger', textTransform: 'uppercase' }}>{data.name}</span>
          </div>
          <div className="account-details-item">

            { data.type && (
              data.type.includes('credit') || data.type.includes('mortgage') || data.type.includes('loan')
                ? (
                  <span className="account-details-item-label">
                    Debit Enabled:
                    <div className="borrowing-account">
                      {' '}
                      NA
                      <span className="pop-over-container">
                        <PopoverHover
                          content={(
                            <div style={{
          maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
        }}
        >
          A credit card, mortgage or loan account cannot be used for debits. Ensure you link a transaction or savings account for debit facilities.
        </div>
                            )}
                          header={null}
                          img={null}
                          itemToPopover={
                              (<i className="material-icons" style={{ margin: '0 5px 0 5px', verticalAlign: '-40%' }}>info</i>)
                            }
                          anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                          }}
                          transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',
                          }}
                        />
                      </span>
                    </div>
                  </span>
                )
                : (
                  <div className="account-details-item-label">
                    Debit Enabled:
                    {debitInfo}
                    <div className="toggle-switch-holder">
                      <ToggleSwitch
                        isChecked={data.debit_enabled}
                        onToggle={() => handleToggleEnableAccountDebit(data.id, 'activeDebitEnabled', rowNumber)}
                        updating={updatingActiveDebitEnabledStates[rowNumber]}
                      />
                    </div>
                  </div>
                )

            )}
            {/* </div> */}
          </div>
          <div className="account-details-item">
            <span className="account-details-item-label">
              Round Up Enabled:
              {roundupInfo}
            </span>
            <div className="toggle-switch-holder">
              <ToggleSwitch
                isChecked={data.roundup_enabled}
                onToggle={() => handleToggleEnableAccountRoundUps(data.id, 'activeRoundUpsEnabled', rowNumber)}
                updating={updatingRoundUpsEnabledStates[rowNumber]}
              />
            </div>
          </div>
          <div className="account-details-item">
            <span className="account-details-item-label">Account Type:&nbsp;</span>
            <span className="account-details-item-data">
              {data.type}
            </span>
          </div>
          <div className="account-details-item">
            <span className="account-details-item-label">Account Holder:&nbsp;</span>
            <span className="account-details-item-data">
              {data.holder_name}
            </span>
          </div>
          <div className="account-details-item">
            <span className="account-details-item-label">Account BSB:&nbsp;</span>
            <span className="account-details-item-data">
              {data.bsb}
            </span>
          </div>
          <div className="account-details-item">
            <span className="account-details-item-label">Account Number:&nbsp;</span>
            <span className="account-details-item-data">
              {data.number}
            </span>
          </div>
          <div className="account-details-item">
            <span className="account-details-item-label">Account Status:&nbsp;</span>
            <span className="account-details-item-data">
              {data.status
                ? data.status.toLowerCase() === 'unavailable' ? (
                  <span className="unavailable">
                    UNAVAILABLE
                    {' '}
                    {unavailableMessage}
                  </span>
                ) : data.status.toLowerCase() === 'available' ? (
                  <span className="available">AVAILABLE</span>
                ) : (
                  <span className="otherstatus">{data.status}</span>
                )
                : <span className="otherstatus"> Unknown</span>}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const columns = [
    {
      name: '#',
      selector: (row, index) => index + 1,
      maxWidth: '60px',
      minWidth: 'unset',
    },
    {
      name: 'Account Name',
      selector: (row) => row.name,
      filterable: false,
      sortable: false,

    },
  ];

  const directDebitRequestContent = (
    <DirectDebitRequestContent
      mode="submit"
      acceptedRoundupsTerms={acceptedRoundupsTerms}
      updatingAcceptedRoundUpTerms={updatingAcceptedRoundUpTerms}
      updatingAccountDebitStatus={updatingAccountDebitStatus}
      onAccept={toggleAcceptedRoundUpTerms}
    />
  );

  return (
    <RoundUpsAcctsTableWrapper>
      <div className="table-container hide-scrollbars">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th style={{ textAlign: 'left' }}>Acct.&nbsp;Name</th>
              <th style={{ textAlign: 'left' }}>Acct.&nbsp;Type</th>
              <th>Holder</th>
              <th>Acct.&nbsp;BSB</th>
              <th>Acct.&nbsp;Number</th>
              <th>
                Debit&nbsp;Enabled
                {debitInfo}
              </th>
              <th>
                Round Up Enabled
                {roundupInfo}
              </th>
              <th>Acct&nbsp;Status</th>
            </tr>
          </thead>
          <tbody>
            {
                      linkedAccounts.map((account, i) => (
                        <tr key={account.id}>
                          <td data-title="Number"><div className="td" style={{ whiteSpace: 'nowrap' }}>{(i + 1)}</div></td>
                          <td data-title="AccountName"><div className="td" style={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{account.name}</div></td>
                          <td data-title="Type"><div className="td" style={{ whiteSpace: 'nowrap' }}>{account.type}</div></td>
                          <td data-title="accountHolderName"><div className="td" style={{ whiteSpace: 'nowrap' }}>{account.holder_name}</div></td>
                          <td data-title="Account BSB"><div className="td" style={{ whiteSpace: 'nowrap' }}>{account.bsb}</div></td>
                          <td data-title="Account Number"><div className="td" style={{ whiteSpace: 'nowrap' }}>{account.number}</div></td>
                          <td data-title="Active Debit">
                            <div className="td" style={{ whiteSpace: 'nowrap' }}>
                              { account.type && (
                                account.type.includes('credit') || account.type.includes('mortgage') || account.type.includes('loan')
                                  ? (
                                    <div className="borrowing-account">
                                      {' '}
                                      NA
                                      <span className="pop-over-container">
                                        <PopoverHover
                                            content={(
                                              <div style={{
                                                maxWidth: '300px', padding: 10, fontSize: '16px', fontWeight: 'bold', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', textAlign: 'left',
                                              }}
                                              >
                                                A credit card, mortgage or loan account cannot be used for debits. Ensure you link a transaction or savings account for debit facilities.
                                              </div>
                                            )}
                                            header={null}
                                            img={null}
                                            itemToPopover={
                                              (<i className="material-icons" style={{ margin: '0 5px 0 5px', verticalAlign: '-40%' }}>info</i>)
                                            }
                                            anchorOrigin={{
                                              vertical: 'center',
                                              horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                              vertical: 'center',
                                              horizontal: 'right',
                                            }}
                                          />
                                      </span>
                                    </div>
                                  )
                                  : (
                                    <ToggleSwitch
                                      isChecked={account.debit_enabled}
                                      onToggle={() => handleToggleEnableAccountDebit(account.id, 'activeDebitEnabled', i)}
                                      updating={updatingActiveDebitEnabledStates[i]}
                                    />
                                  )
                              )}
                            </div>
                          </td>

                          <td data-title="Active Round Ups">
                            <div className="td" style={{ whiteSpace: 'nowrap' }}>
                              <ToggleSwitch
                                isChecked={account.roundup_enabled}
                                onToggle={() => handleToggleEnableAccountRoundUps(account.id, 'activeRoundUpsEnabled', i)}
                                updating={updatingRoundUpsEnabledStates[i]}
                              />
                            </div>
                          </td>
                          <td data-title="Account Status">
                            <div className="td" style={{ whiteSpace: 'nowrap' }}>
                              {account.status
                                ? account.status.toLowerCase() === 'unavailable' ? (
                                  <span className="unavailable">
                                    UNAVAILABLE
                                    {' '}
                                    {unavailableMessage}
                                  </span>
                                ) : account.status.toLowerCase() === 'available' ? (
                                  <span className="available">AVAILABLE</span>
                                ) : (
                                  <span className="otherstatus">{account.status}</span>
                                )
                                : <span className="otherstatus">Unknown</span>}
                            </div>
                          </td>

                        </tr>
                      ))
                    }
          </tbody>
        </table>

      </div>

      <DataTable
        title={null}
        columns={columns}
        data={linkedAccounts}
        expandableRows
        expandableRowsComponent={(props) => <ExpandedComponent {...props} index={props.index} />}
            // expandableRowsComponent={ExpandedComponent}
        expandOnRowClicked
            // defaultExpanded={true}
        expandableRowExpanded={(row) => linkedAccounts.length > 0 && row.id === linkedAccounts[0].id}
      />

      <ModalDialogV3
        open={showRoundUpTermsModal}
        onCloseModalDialogV3={closeRoundUpTermsModal}
        titleComponent="Zai Australia Pty Ltd Direct Debit Request Service Agreement"
        explainerComponent={null}
        contentComponent={directDebitRequestContent}
      />

    </RoundUpsAcctsTableWrapper>

  );
};

RoundUpsAcctsTable.propTypes = {
  onError: PropTypes.func.isRequired,
};

export default RoundUpsAcctsTable;
